import React from 'react';
import { Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

const MarqueeSection = () => {
  const items = [
    {
      text: "Healthcare costs are higher in the US compared to the rest of the world",
      icon: <QueryStatsIcon sx={{ mr: 1 }} />
    },
    {
      text: "Americans pay 3.5x more for prescription drugs",
      icon: <AttachMoneyIcon sx={{ mr: 1 }} />
    },
    {
      text: "Drug prices have increased 35% since 2014",
      icon: <TrendingUpIcon sx={{ mr: 1 }} />
    }
  ];

  // Double the items to ensure smooth infinite loop
  const marqueeItems = [...items, ...items, ...items, ...items];

  return (
    <Box
      sx={{
        backgroundColor: '#43c5b9',
        py: 2,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
      <Box
        sx={{
          display: 'flex',
          animation: 'scroll 40s linear infinite',
          '&:hover': {
            animationPlayState: 'paused'
          }
        }}
      >
        {marqueeItems.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              mx: 4,
              color: 'white',
            }}
          >
            {item.icon}
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: '14px', md: '16px' },
                fontFamily: 'inherit'
              }}
            >
              {item.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MarqueeSection;
